<template>
	<div>
		<div class="help-button-vertical" @click="openHelp">
			Support
		</div>
        
	</div>
</template>

<script>
	export default {
		methods: {
			openHelp() {
				FreshworksWidget('open');
			}
		}
	};
</script>

<style scoped>
	.help-button-vertical {
		position: fixed;
		right: -2px; /* Initial position slightly overlapping the edge */
		top: 50%; /* Vertically center the button */
		z-index: 1000; /* Ensure it appears above other elements */
		background-color: #D81B60; /* Button background color */
		color: white;
		font-weight: bold;
		padding: 10px 8px;
		border-radius: 0px 4px 4px 0px; /* Rounded corners */
		box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2); /* Subtle shadow */
		writing-mode: vertical-rl; /* Text flows bottom-to-top */
		text-orientation: mixed; /* Proper text alignment for vertical writing */
		text-align: center;
		cursor: pointer;
		width: 35px; /* Width of the button */
		height: auto;
		transform: rotateZ(180deg); /* Rotate the text to flow bottom-to-top */
		transition: right 0.3s ease, box-shadow 0.3s ease; /* Smooth animation */
	}

	.help-button-vertical:hover {
		right: 0; /* Move further into the screen */
		box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.3); /* Enhanced shadow on hover */
	}
</style>
